import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/header/Header";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import SignIn from "../components/signin";
import { useAuth } from "../contexts/AuthContext";
import "./Login.scss";

function Login(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    document.title = "Login - Talsolution";
    return () => {
      document.title = "Talsolution";
    };
  }, []);

  // Redirect if already logged in
  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from || "/dashboard";
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  // Check if this is an employer login
  const isEmployerLogin = location.search.includes("type=employer");

  return (
    <>
      <Header />
      <section className="login-page-section">
        <div className="login-page-container">
          <div className="login-page-content">
            <SignIn isEmployerLogin={isEmployerLogin} />
          </div>
        </div>
      </section>
      <Footer />
      <Gotop />
    </>
  );
}

export default Login;
